<template>
    <div>
        <b-tabs active-nav-item-class="nav-pill-secondary" pills>
            <b-tab v-if="type != 2" title="Rezervasyon Fiyat" active>
                <draft-price-reservation-price v-model="value" :one-day-km="oneDayKm"></draft-price-reservation-price>
            </b-tab>
            <b-tab v-if="type == 2" title="Manuel Rota" active>
                <draft-price-route-manual v-model="value" :one-day-km="oneDayKm"></draft-price-route-manual>
            </b-tab>
            <b-tab v-if="type == 2" title="Kesin Adrese Dayalı Rota">
                <draft-price-route-exact v-model="value" :one-day-km="oneDayKm"></draft-price-route-exact>
            </b-tab>
            <b-tab v-if="type == 2" title="Excel İle Rota Yükleme" >
                <draft-price-route-excel v-model="value" :one-day-km="oneDayKm"></draft-price-route-excel>
            </b-tab>
            <b-tab v-if="type == 2" title="İlçe Bazlı" >
                <draft-price-route-district-base v-model="value" :one-day-km="oneDayKm"></draft-price-route-district-base>
            </b-tab>
        </b-tabs>
        <draft-price-calculated-routes v-model="value" :one-day-km="oneDayKm" :type="type"></draft-price-calculated-routes>
    </div>
</template>

<script>
import {BTab,BTabs} from 'bootstrap-vue'
import DraftPriceRouteManual from '@/views/calculate-price/draft-price/components/DraftPriceRouteManual'
import DraftPriceRouteExcel from '@/views/calculate-price/draft-price/components/DraftPriceRouteExcel'
import DraftPriceRouteExact from '@/views/calculate-price/draft-price/components/DraftPriceRouteExact'
import DraftPriceRouteDistrictBase from '@/views/calculate-price/draft-price/components/DraftPriceRouteDistrictBase'
import DraftPriceCalculatedRoutes from '@/views/calculate-price/draft-price/components/DraftPriceCalculatedRoutes'
import DraftPriceReservationPrice from '@/views/calculate-price/draft-price/components/DraftPriceReservationPrice.vue'
import SystemConstantParametersApi from '@/api/system-constant-parameters'


export default {
    props:{
        value:Object,
        type:Number
    },
    data(){
        return{
            oneDayKm:Number.POSITIVE_INFINITY
        }
    },
    components:{
        BTab,
        BTabs,
        DraftPriceRouteManual,
        DraftPriceRouteExcel,
        DraftPriceCalculatedRoutes,
        DraftPriceRouteExact,
        DraftPriceReservationPrice,
        DraftPriceRouteDistrictBase
    },
    mounted(){
        this.getOneDayKm()
    },
    methods:{
        getOneDayKm(){
            SystemConstantParametersApi.GetByCode('ONE_DAY_KM_INFO_FOR_DRIVER').then(response=>{
                this.oneDayKm = Number(response.data.Data) ? Number(response.data.Data) : Number.POSITIVE_INFINITY
            })
        }
    }
}
</script>

<style>

</style>